import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MenuComponent } from './chat/menu/menu.component';
import { ListComponent } from './chat/list/list.component';
import { RoomComponent } from './chat/room/room.component';
import { ChatComponent } from './chat/chat.component';
import { DashboardComponent } from './dashboard.component';

import { ChangepassComponent } from './changepass/changepass.component';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { SocketioService } from './socketio.service';
import { DashboardService } from './dashboard.service';
import { HttpModule } from '@angular/http';

import { SharedModule } from '../shared/shared.module';
import { ModalModule } from 'ngx-bootstrap/modal';
// Archivos adjuntos
import { Ng4FilesModule } from 'angular4-files-upload';
// Emoticones
import {EmojiPickerModule} from 'ng-emoji-picker';
import  {  NgxEmojiPickerModule  }  from  'ngx-emoji-picker';
// filtro de busqueda
import { Ng2SearchPipeModule } from 'ng2-search-filter';

// evento al generar scroll

import { ScrollEventModule } from 'ngx-scroll-event';

//Spinner
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxSpinnerService } from 'ngx-spinner';
import { PushNotificationService } from 'ngx-push-notifications';
import { RoomService } from './chat/room/room.service';
import { HttpClientModule } from '@angular/common/http';
import { DndDirective } from './dnd.directive';
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatButtonModule } from "@angular/material/button";
import {MatExpansionModule} from '@angular/material/expansion';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { InforoomComponent } from './chat/inforoom/inforoom.component';
import { VideoCall } from '../admin/video-call/video-call.component';
import { AngularMultiSelectModule } from 'angular4-multiselect-dropdown/angular4-multiselect-dropdown';
import { NgSelectModule } from '@ng-select/ng-select';
import { VideoCallService } from '../admin/video-call/video-call.service';
import { NavService } from "./nav.service";
import { MentionModule } from 'angular-mentions';
import {TreeModule} from 'primeng/tree';
import {TreeNode} from 'primeng/api';
import {ButtonModule} from 'primeng/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';


@NgModule({ 
  imports: [
    CommonModule,
    DashboardRoutingModule,
    Ng2SearchPipeModule,
    HttpModule,
    AngularMultiSelectModule,
    ModalModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    Ng4FilesModule,
    FormsModule,
    ReactiveFormsModule,
    EmojiPickerModule,
    NgxEmojiPickerModule,
    ScrollEventModule,
    SharedModule,
    NgxSpinnerModule,
    MatIconModule,
    MatListModule,
    MatSidenavModule,
    MatToolbarModule,
    MatButtonModule,
    MatExpansionModule,
    MentionModule,
    TreeModule,
    ButtonModule,
    HttpClientModule,
    NgSelectModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  declarations: [
  MenuComponent,
  ListComponent,
  RoomComponent,
  DashboardComponent,
  ChatComponent,
  ChangepassComponent,
  DndDirective,
  InforoomComponent,
  VideoCall
  ],

  providers: [
  RoomService,  
  SocketioService,
  PushNotificationService,
  DashboardService,
  NgxSpinnerService,
  NavService,
  VideoCallService
  ],
  exports: [RoomComponent]

})
export class DashboardModule { }



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/dashboard/dashboard.module.ts